var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#DFDFE7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5778_23023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 12,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96967 7.38886C7.26256 7.12038 7.73744 7.12038 8.03033 7.38886L17.0303 15.6389C17.3232 15.9074 17.3232 16.3427 17.0303 16.6111C16.7374 16.8796 16.2626 16.8796 15.9697 16.6111L6.96967 8.36114C6.67678 8.09265 6.67678 7.65735 6.96967 7.38886Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0303 7.38886C16.7374 7.12038 16.2626 7.12038 15.9697 7.38886L6.96967 15.6389C6.67678 15.9074 6.67678 16.3427 6.96967 16.6111C7.26256 16.8796 7.73744 16.8796 8.03033 16.6111L17.0303 8.36114C17.3232 8.09265 17.3232 7.65735 17.0303 7.38886Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5778_23023)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.5,
    width: 12,
    height: 11,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.04e7c6129f3a2f58068b8dda24e2995a.svg";
export { ForwardRef as ReactComponent };